import React, { forwardRef } from "react";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import classNames from "classnames";

export interface IBlogContentProps extends IEditableProps, IStyledProps {
    children;
}

const BlogContent = forwardRef((props: IBlogContentProps, ref: any) => {
    const { className, children, editorClassObj, cmsId } = props;

    return (
        <div data-id={cmsId} ref={ref} className={classNames("content border-0", className, editorClassObj)}>
            {children}
        </div>
    );
});

export default BlogContent;
